module.exports = __webpack_public_path__ + "static/media/25.69cb64a7.jpg";